module.exports = __webpack_public_path__ + "static/media/logo_criatec_colorida.d9979acd.png";